import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4e5c28e1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c28e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/api/master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e5c28e1')) {
      api.createRecord('4e5c28e1', component.options)
    } else {
      api.reload('4e5c28e1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4e5c28e1&scoped=true&", function () {
      api.rerender('4e5c28e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/app/components/user/index.vue"
export default component.exports